
import { defineStore } from 'pinia';

export const useUIStore = defineStore('ui', {
  state: () => ({
    showAuthModal: false,
    showWelcomeModal: false,
    showUploadModal: false
  }),
  
  actions: {
    toggleAuthModal() {
      this.showAuthModal = !this.showAuthModal;
    },
    toggleWelcomeModal() {
      this.showWelcomeModal = !this.showWelcomeModal;
    },
    toggleUploadModal() {
      this.showUploadModal = !this.showUploadModal;
    }
  }
});
